<template>
<!-- Add Registrar -->
  <div class="vx-row">
    <vx-card class="centered-page-container">
      <form class="add-partner-tabs" @submit.prevent="submit">
        <div class="vx-row flex-wrap px-5">
          <h2 class="partner-page-title"> Add Registrar - CNIC</h2>
        </div>

        <hr>

        <div class="indent-section add-reg-tabs">
          <div class="tab-text">
            <div class="vx-row mt-10">
              <div class="vx-col">
                <h5 class="tab-title">Registrar Details</h5>
              </div>
            </div>

            <div class="vx-row mt-6">
              <div class="vx-col w-1/4">
                <label class="vs-input--label inline-flex pb-2">Registrar Name *</label>
                <vs-input
                  class="w-full"
                  v-validate="{ required: !formDataRegistrar['legal_name'] }"
                  name="Registrar Name"
                  data-vv-validate-on="change"
                  mode="lazy"
                  v-model="formDataRegistrar['legal_name']" 
                  :danger="errors.has('Registrar Name')"
                  danger-text="Required field"/>
              </div>

              <div class="vx-col w-1/4">
                <label class="vs-input--label inline-flex pb-2">Registrar Short Name *</label>
                <vs-input
                  class="w-full"
                  v-validate="{ required: !formDataRegistrar['name'], max:50, regex: /^[a-zA-Z0-9]+(?:[ ]?[a-zA-Z0-9]+)*$/ }"
                  name="Registrar Short Name"
                  data-vv-validate-on="change"
                  mode="lazy"
                  :danger="errors.has('Registrar Short Name') || (formDataRegistrar['name'] ? formDataRegistrar['name'].length : 0) > 50"
                  :danger-text="errors.has('Registrar Short Name') ? (errors.items.find(x => x.field == 'Registrar Short Name').rule == 'required' ? 'Required field' : errors.items.find(x => x.field == 'Registrar Short Name').msg) : characterCount"
                  v-model="formDataRegistrar['name']" />
              </div>

              <div class="vx-col w-1/4">
                <label class="vs-input--label inline-flex pb-2">Account Manager</label>
                <v-select
                  name="Account Manager"
                  class="w-full"
                  v-model="formDataRegistrar['accountManager']"
                  :options="formAMs"
                  :closeOnSelect="true"
                  :clearable="false"></v-select>
              </div>

              <div class="vx-col w-1/4">
                <label class="vs-input--label inline-flex pb-2">Country</label>
                <v-select
                  name="Country"
                  class="w-full"
                  v-model="formDataRegistrar['country']"
                  :options="formGeo"
                  :closeOnSelect="true"
                  :clearable="false"></v-select>
              </div>
            </div>

            <div class="vx-row mt-4">
              <div class="vx-col w-1/4">
              <label class="vs-input--label inline-flex pb-2">Website</label>
                <vs-input
                  class="w-full"
                  name="Website"
                  v-model="formDataRegistrar['website']" 
                  v-validate="'url'"
                  data-vv-validate-on="change"
                  :danger="formDataRegistrar['website'] ? errors.has('Website') : false"
                  :danger-text="'Invalid URL'"/>
              </div>
            </div>

            <div class="vx-row mt-4" v-for="(id, index) in formDataRegistrar['cnic_iana_ids']" :key="`CNICIANA-${index}`">
              <div class="vx-col w-1/4">
                <label class="vs-input--label inline-flex pb-2">IANA ID *</label>
                <vs-input
                  class="w-full"
                  type="number"
                  :name="`IANA ID-${index}`"
                  v-model="id['iana_id']"
                  v-validate="{ required: !index && !(id['iana_id'] || id['cnic_id']) }"
                  data-vv-validate-on="change"
                  :danger="errors.has(`IANA ID-${index}`)"
                  danger-text="IANA ID or CNIC ID is required" />
              </div>

              <div class="vx-col w-1/4">
                <label class="vs-input--label inline-flex pb-2">CNIC ID *</label>
                <vs-input
                  class="w-full"
                  :name="`CNIC ID-${index}`"
                  v-model="id['cnic_id']"
                  v-validate="{ required: !index && !(id['iana_id'] || id['cnic_id']) }"
                  data-vv-validate-on="change"
                  :danger="errors.has(`CNIC ID-${index}`)"
                  danger-text="IANA ID or CNIC ID is required" />
              </div>

              <div>
                <vs-button
                  v-show="formDataRegistrar['cnic_iana_ids'].length > 1"
                  color="danger"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-x"
                  class="mt-8"
                  @click="removeIANACNICIDGroup(index)"></vs-button>
              </div>

              <div v-if="index == formDataRegistrar['cnic_iana_ids'].length - 1" class="vx-col w-1/4 mt-8">
                <vs-button color="black" type="filled" icon-pack="feather" icon="icon-plus" class="add-more-btn" @click="addIANACNICIDGroup()">Add</vs-button>
              </div>
            </div>

            <hr class="my-12">

            <div class="vx-row">
              <vs-button class="mt-2 ml-auto" type="filled" button="submit" icon-pack="feather" icon="icon-save">Save</vs-button>
            </div>
          </div>
        </div>
      </form>
    </vx-card>

    <!-- Error Prompt -->
    <custom-prompt :activePrompt.sync="customPrompt['activePrompt']" :title="customPrompt['title']" :buttonText="customPrompt['buttonText']" :type="customPrompt['type']" :color="customPrompt['color']" :classList="customPrompt['classList']">
      <div class="con-content" slot="content">
        <p>Please solve the following errors: <br><ul class="error-body">{{ customPromptError }}</ul></p>
      </div>
    </custom-prompt>
    <!--  -->
  </div>
<!--  -->
</template>

<script>
import vSelect from "vue-select";
import CustomPrompt from "@/components/CustomPrompt.vue";

export default {
  name: 'AddCNICRegistrar',
  components: {
    "v-select": vSelect,
    CustomPrompt
  },
  data() {
    return {
      formDataRegistrar: {
        legal_name: null,
        name: null,
        accountManager: {
          label: 'NA',
          value: null
        },
        country: {
          label: 'NA',
          value: null
        },
        website: null,
        cnic_iana_ids: [{
          cnic_id: null,
          iana_id: null
        }]
      },
      customPrompt: {
        activePrompt: false,
        title: null,
        buttonText: null,
        type: null,
        color: null,
        classList: null,
        accept: null
      },
      customPromptError: null
    }
  },
  computed: {
    user_role() {
      return JSON.parse(localStorage.getItem("userDetails")).role;
    },
    user_id() {
      return JSON.parse(localStorage.getItem("userDetails")).id;
    },
    formGeo() {
      return this.$store.getters.formGeo;
    },
    formAMs() {
      return this.$store.getters.formAMs;
    },
    characterCount() {
      return 'Character Count: ' + (this.formDataRegistrar['name'] ? this.formDataRegistrar['name'].length : 0) + '/50';
    }
  },
  watch: {
    user_role() {
      return JSON.parse(localStorage.getItem("userDetails")).role;
    },
    user_id() {
      return JSON.parse(localStorage.getItem("userDetails")).id;
    },
    formGeo() {
      return this.$store.getters.formGeo;
    },
    formAMs() {
      return this.$store.getters.formAMs;
    }
  },
  methods: {
    addIANACNICIDGroup() {
      this.formDataRegistrar['cnic_iana_ids'].push({
        iana_id: '',
        cnic_id: ''
      });
    },
    removeIANACNICIDGroup(index) {
      this.formDataRegistrar['cnic_iana_ids'].splice(index, 1);
    },
    submit() {
      // NOTE: Validate the form before submission
      this.$validator.validate().then(async (valid) => {
        if(valid) {
          var payload = {
            legal_name: this.formDataRegistrar['legal_name'],
            name: this.formDataRegistrar['name'],
            am_id: this.formDataRegistrar['accountManager'].value,
            country_id: this.formDataRegistrar['country'].value,
            website: this.formDataRegistrar['website'],
            cnic_iana_ids: this.formDataRegistrar['cnic_iana_ids']
          }
  
          this.$axiosSecure
          .post('/unique-registrars', payload)
          .then((response) => {
            if(response.data.type == 'Success') {
              this.resetForm();

              this.$vs.dialog({
                color: 'success',
                title: 'Success',
                text: 'Registrar added successfully!',
                acceptText: 'Close',
                accept: () => {},
              });

              // NOTE: Reset Form validation after submit
              this.$validator.pause()
              this.$nextTick(() => {
                this.$validator.errors.clear();
                this.$validator.fields.items.forEach(field => field.reset());
                this.$validator.fields.items.forEach(field => this.errors.remove(field));
                this.$validator.resume();
              })
            } else {
              let liStr = '';
              response.data.message.forEach((el, index) => {
                liStr += `${index+1}. ${el}<br>`
              })
              this.customPromptError = liStr;
              this.customPrompt["type"] = "error";
              this.customPrompt["classList"] = "danger-prompt";
              this.customPrompt["color"] = "danger";
              this.customPrompt["activePrompt"] = true;
            }
          })
          .catch((error) => {
            let liStr = '';
            error.response.data.message.forEach((el, index) => {
              liStr += `${index+1}. ${el}`
            })
            this.customPromptError = liStr;
            this.customPrompt["type"] = "error";
            this.customPrompt["classList"] = "danger-prompt";
            this.customPrompt["color"] = "danger";
            this.customPrompt["activePrompt"] = true;
          });
        } else {
          var errors = this.errors.collect();
        }
      })
    },
    resetForm() {
      this.formDataRegistrar = {
        legal_name: null,
        name: null,
        accountManager: {
          label: 'NA',
          value: null
        },
        country: {
          label: 'NA',
          value: null
        },
        website: null,
        cnic_iana_ids: [{
          cnic_id: null,
          iana_id: null
        }]
      }

      this. customPrompt = {
        activePrompt: false,
        title: null,
        buttonText: null,
        type: null,
        color: null,
        classList: null,
        accept: null
      }
    }
  }
}
</script>